<template>
  <div class="Qua">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "Qua"
};
</script>
